import gsap from 'gsap'
import SmoothScroll from '../utils/SmoothScroll'

export default class CompanyMenu {
	constructor() {
		const menus = document.querySelectorAll('[data-subcompany-tease]')
		if (menus.length === 0) return

		this.lenis = new SmoothScroll().lenis
		this.overlay = document.querySelector('[data-subcompanymenu-overlay]')
		this.isOpen = false

		const containers = [...new Set([...menus].map((t) => t.parentElement))]
		containers.forEach((container) => this.#initMenu(container))

		this.#initToggle()
	}

	#open(menu) {
		this.isOpen = true
		gsap.to(menu, { x: 0, duration: 0.7, ease: 'power3.inOut' })
		this.overlay?.classList.add('active')
		this.lenis.stop()
		this.#staggerIn(menu)
	}

	#close(menu) {
		if (!this.isOpen) return
		this.isOpen = false
		gsap.to(menu, { x: '100%', duration: 0.7, ease: 'power3.inOut' })
		this.overlay?.classList.remove('active')
		this.lenis.start()
		this.#resetStagger(menu)
	}

	#closeAll() {
		if (!this.isOpen) return
		this.isOpen = false
		document.querySelectorAll('[data-subcompany-menu]').forEach((menu) => {
			gsap.to(menu, { x: '100%', duration: 0.7, ease: 'power3.inOut' })
			this.#resetStagger(menu)
		})
		this.overlay?.classList.remove('active')
		this.lenis.start()
	}

	#staggerIn(menu) {
		const children = menu.querySelectorAll(
			'[data-subcompany-menu-header] > *, [data-subcompany-tease]'
		)
		gsap.fromTo(
			children,
			{ opacity: 0, y: 32 },
			{
				opacity: 1,
				y: 0,
				duration: 0.5,
				ease: 'power2.out',
				stagger: 0.1,
				delay: 0.45,
			}
		)
	}

	#resetStagger(menu) {
		const children = menu.querySelectorAll(
			'[data-subcompany-menu-header] > *, [data-subcompany-tease]'
		)
		gsap.killTweensOf(children)
		gsap.set(children, { clearProps: 'all' })
	}

	#initToggle() {
		const openButtons = document.querySelectorAll('[data-open-subcompany-menu]')
		const closeButtons = document.querySelectorAll(
			'[data-close-subcompany-menu]'
		)
		const menus = document.querySelectorAll('[data-subcompany-menu]')

		openButtons.forEach((button) => {
			button.addEventListener('click', () => {
				const companyId = button.closest('[data-company-id]')?.dataset.companyId
				const menu = companyId
					? document.querySelector(`[data-subcompany-menu][data-company-id="${companyId}"]`)
					: null
				if (menu) this.#open(menu)
			})
		})

		closeButtons.forEach((button) => {
			const menu = button.closest('[data-subcompany-menu]')
			button.addEventListener('click', () => this.#close(menu))
		})

		this.overlay?.addEventListener('click', () => this.#closeAll())

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') this.#closeAll()
		})

		document.addEventListener('click', (e) => {
			if (
				!e.target.closest('[data-subcompany-menu]') &&
				!e.target.closest('[data-open-subcompany-menu]')
			) {
				this.#closeAll()
			}
		})
	}

	#initMenu(scrollContainer) {
		const aside = scrollContainer.parentElement
		const buttons = aside.querySelectorAll('[data-subcompany-button]')
		const teases = scrollContainer.querySelectorAll('[data-subcompany-tease]')

		if (buttons.length === 0 || teases.length === 0) return

		buttons.forEach((button, i) => {
			button.addEventListener('click', (e) => {
				e.preventDefault()
				buttons.forEach((b, j) => b.classList.toggle('active', j === i))
				teases[i]?.scrollIntoView({ behavior: 'smooth', block: 'start' })
			})
		})

		scrollContainer.addEventListener('scroll', () => {
			let closestIndex = 0
			let closestDistance = Infinity

			teases.forEach((tease, i) => {
				const distance = Math.abs(
					tease.offsetTop -
						scrollContainer.offsetTop -
						scrollContainer.scrollTop
				)
				if (distance < closestDistance) {
					closestDistance = distance
					closestIndex = i
				}
			})

			buttons.forEach((b, j) =>
				b.classList.toggle('active', j === closestIndex)
			)
		})
	}
}
